module.exports = __webpack_public_path__ + "img/徐水酿酒.cacb155d.jpg";